class ProductVariantDropdown extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      if (document.querySelectorAll('.template-product').length && !this.closest('#content_quickview')) {
        this.updateURL();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.productId}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    const itemact = document.querySelectorAll('.proFeaturedImage .item');
    for (var i = 0; i < itemact.length; i++) {
      itemact[i].classList.remove('act')
    }
    newMedia.classList.add('act');
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.productUrl}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('fieldset')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId;
    fetch(`${this.dataset.productUrl}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPrice-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
        const variant_id = document.getElementById("variant_id").getAttribute('value');
        const sku = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-sku');
        const variantSku = document.getElementById('variantSku');
        if (typeof variantSku !== 'undefined' && variantSku) {
          variantSku.innerHTML = sku;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variant_id = document.getElementById("variant_id").getAttribute('value');
      const inventoryPolicy = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_policy');
      const inventoryManagement = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_management');
      if(inventoryPolicy == 'continue' && inventoryManagement == 'shopify' ) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.productId}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('product-variant-dropdown', ProductVariantDropdown);

class ProductVariantSwatch extends ProductVariantDropdown {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('product-variant-swatch', ProductVariantSwatch);

class ProductVariantSelectsStick extends ProductVariantDropdown {
  constructor() {
    super();
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-sticky-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(`${this.dataset.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPriceStick-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-sticky-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variant_id = document.getElementById("variant_id").getAttribute('value');
      const inventoryPolicy = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_policy');
      const inventoryManagement = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_management');
      if(inventoryPolicy == 'continue' && inventoryManagement == 'shopify' ) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addTobag;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-sticky-${this.dataset.productId}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
}

customElements.define('product-variant-selects-stick', ProductVariantSelectsStick);



  /* ----------------------------
     FAQ TOGGLE FUNCTIONALITY
  -----------------------------*/
  const faqHeaders = document.querySelectorAll('.faq-header');

  faqHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const faqItem = header.parentElement;
      const content = faqItem.querySelector('.faq-content');
      const toggle = header.querySelector('.faq-toggle');
      const expanded = header.getAttribute('aria-expanded') === 'true';

      // Toggle aria attribute
      header.setAttribute('aria-expanded', !expanded);

      if (expanded) {
        content.style.maxHeight = null;
        toggle.textContent = '+';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        toggle.textContent = '−';
      }
    });
  });

  /* ----------------------------
   READ MORE FUNCTIONALITY
-----------------------------*/
// document.addEventListener('DOMContentLoaded', function () {
//   const readMoreBtn = document.querySelector('.read-more-btn');
//   const shortDesWrapper = document.querySelector('.product-single__shortdes-wrapper');
//   const shortDes = document.querySelector('.product-single__shortdes');

//   if (readMoreBtn && shortDes) {
//     // Store original full description
//     const fullHTML = shortDes.innerHTML.trim();

//     // Extract plain text and count words
//     const textOnly = shortDes.textContent.trim();
//     const words = textOnly.split(/\s+/);
//     const limit = 20; // same as Liquid condition in your code

//     // If description has more than 20 words, make short version
//     if (words.length > limit) {
//       const shortText = words.slice(0, limit).join(' ') + '...';
//       shortDes.innerHTML = `<p>${shortText}</p>`;
//       let expanded = false;

//       readMoreBtn.addEventListener('click', function () {
//         if (!expanded) {
//           // Expand: show full description (with HTML)
//           shortDes.innerHTML = fullHTML;
//           readMoreBtn.textContent = 'Read less';
//           shortDesWrapper.classList.add('expanded');
//           expanded = true;
//         } else {
//           // Collapse: show only limited text again
//           shortDes.innerHTML = `<p>${shortText}</p>`;
//           readMoreBtn.textContent = 'Read more';
//           shortDesWrapper.classList.remove('expanded');
//           expanded = false;
//         }
//       });
//     } else {
//       // Hide button if short description
//       readMoreBtn.style.display = 'none';
//     }
//   }
// });


// document.addEventListener('DOMContentLoaded', function () {
//   const defaultVariantScript = document.getElementById('defaultVariantScript');
//   if (!defaultVariantScript) return;

//   try {
//     const defaultData = JSON.parse(defaultVariantScript.textContent);
//     const defaultVariantId = defaultData.default_variant_id;
//     if (!defaultVariantId) return;

//     // Small delay to ensure Shopify variant scripts are initialized
//     setTimeout(() => {
//       const productSelect = document.getElementById('productSelect');
//       if (!productSelect) return;

//       const defaultOption = productSelect.querySelector(`option[value="${defaultVariantId}"]`);
//       if (!defaultOption) return;

//       // Only change if not already selected
//       if (productSelect.value !== defaultVariantId) {
//         productSelect.value = defaultVariantId;

//         // Update the hidden input if exists
//         const variantInput = document.getElementById('variant_id');
//         if (variantInput) variantInput.value = defaultVariantId;

//         // Update URL
//         const currentUrl = new URL(window.location.href);
//         currentUrl.searchParams.set('variant', defaultVariantId);
//         window.history.replaceState({}, '', currentUrl);

//         // Trigger variant change
//         productSelect.dispatchEvent(new Event('change', { bubbles: true }));

//         // If you have custom variant dropdown or stick section, re-run update
//         const dropdownEl = document.querySelector('product-variant-dropdown');
//         const stickEl = document.querySelector('product-variant-selects-stick');

//         if (dropdownEl && typeof dropdownEl.onVariantChange === 'function') dropdownEl.onVariantChange();
//         if (stickEl && typeof stickEl.onVariantChange === 'function') stickEl.onVariantChange();
//       }
//     }, 400); // wait 400ms for variant scripts to initialize
//   } catch (e) {
//     console.error('Default variant metafield error:', e);
//   }
// });